module.exports = __webpack_public_path__ + "static/media/RocketWhite.9b6e0425.svg";